import jwtInterceptor from "./jwtInterceptor";
import {ELASTIC_COMMUNE_ENDPOINTS} from "../utils/api";

class CommuneService {

    async getAllCommunes() {
        const response = await jwtInterceptor.get(ELASTIC_COMMUNE_ENDPOINTS.getDistinctCommune);
        return response.data.data
    }
}

export const communeService = new CommuneService();